<h1 mat-dialog-title>
  <div class="hiddenDiv"></div>
  <span>{{ 'k004248' | translate }}</span>
  <!-- Token: Verification step -->
  <div *ngIf="showBtoCloseModal" mat-button mat-dialog-close class="btoCLoseModal"><span>×</span></div>
</h1>
<div mat-dialog-content *ngIf="showVerificationCode">
  <form [formGroup]="form" class="formPhone w-100 fadeIn" autocomplete="off">
    <p *ngIf="forSMS; else forMail" class="text-center">
      {{ 'k004249' | translate }}
      <!-- Token: This is a verification step. Please, enter the code we have just sent to your phone -->
    </p>
    <ng-template #forMail>
      <p class="text-center">
        {{ 'k004250' | translate }}
        
        <!-- Token: This is a verification step. Please, enter the code we have just sent to your email -->
      </p>
    </ng-template>
    <div *ngIf="showContentinput" class="contentinput">
      <mat-form-field class="mr-2">
        <input
          autocomplete="off"
          type="number"
          matInput
          id="code01"
          #code01
          name="code01"
          formControlName="code01"
          class="inp-item"
          onKeyPress="if(this.value.length==1) return false;"
          max="9"
          pattern="\d*"
          maxlength="1"
          (keyup)="keyupcode($event, 1)"
          (paste)="pastecode($event)"
        />
      </mat-form-field>
      <mat-form-field class="mr-2">
        <input
          autocomplete="nothing"
          type="number"
          matInput
          id="code02"
          #code02
          name="code02"
          formControlName="code02"
          class="inp-item"
          onKeyPress="if(this.value.length==1) return false;"
          max="9"
          pattern="\d*"
          maxlength="1"
          (keyup)="keyupcode($event, 2)"
        />
      </mat-form-field>
      <mat-form-field class="mr-2">
        <input
          autocomplete="nothing"
          type="number"
          matInput
          id="code03"
          #code03
          name="code03"
          formControlName="code03"
          class="inp-item"
          onKeyPress="if(this.value.length==1) return false;"
          max="9"
          pattern="\d*"
          maxlength="1"
          (keyup)="keyupcode($event, 3)"
        />
      </mat-form-field>
      <mat-form-field class="mr-2">
        <input
          autocomplete="nothing"
          type="number"
          matInput
          id="code04"
          #code04
          name="code04"
          formControlName="code04"
          class="inp-item"
          onKeyPress="if(this.value.length==1) return false;"
          max="9"
          pattern="\d*"
          maxlength="1"
          (keyup)="keyupcode($event, 4)"
        />
      </mat-form-field>
      <mat-form-field class="mr-2">
        <input
          autocomplete="nothing"
          type="number"
          matInput
          id="code05"
          #code05
          name="code05"
          formControlName="code05"
          class="inp-item"
          onKeyPress="if(this.value.length==1) return false;"
          max="9"
          pattern="\d*"
          maxlength="1"
          (keyup)="keyupcode($event, 5)"
        />
      </mat-form-field>
      <mat-form-field class="mr-2">
        <input
          autocomplete="nothing"
          type="number"
          matInput
          id="code06"
          #code06
          name="code06"
          formControlName="code06"
          class="inp-item"
          onKeyPress="if(this.value.length==1) return false;"
          max="9"
          pattern="\d*"
          maxlength="1"
          (keyup)="keyupcode($event, 6)"
        />
      </mat-form-field>
    </div>
    <div *ngIf="!showContentinput" class="noContentinput">
      <tech-loading-peq></tech-loading-peq>
    </div>
    <p class="codeWrong fadeIn" *ngIf="showCodeWrong">
      {{ 'k004253' | translate }}
      </p>
      <!-- Token: Oh! Code is off. We send a new one and try again. -->
    <p class="blue2 text-center fadeIn" *ngIf="showClickResentCode"><small>
      {{ 'k004251' | translate }}
      <!-- Token: If you didn't receive it, you can request it again by -->
      <a class="clickHere" (click)="resendCode()">{{
        'k001645' | translate
      }}</a></small></p
    >
    <!-- Token: Click here -->
    <p class="blue2 text-center textResentCode fadeIn" *ngIf="showTextResentCode"><small>
      {{ 'k004306' | translate }}</small></p>
      <!-- Token: Code successfully resent -->
  </form>
  
</div>
<div class="fadeIn" mat-dialog-content *ngIf="showVerificationCodeOK">
  <tech-two-faok></tech-two-faok>
</div>
<div class="fadeIn" mat-dialog-content *ngIf="showTooManyAttempts">
  <tech-too-many-attempts></tech-too-many-attempts>
</div>
<div class="fadeIn" mat-dialog-content *ngIf="showProtectText">
  <p>{{ 'k004254' | translate }}</p>
  <!-- Token: To protect your account and avoid automated attacks, you must wait a bit before trying to enter the code again, as there have been too many incorrect attempts.-->
</div>
<div class="fadeIn"mat-dialog-content *ngIf="showMessageConflict">
  <p>{{messageConflict}}</p>
  <p class="blue2 text-center fadeIn" *ngIf="showClickResentCode"><small>
    {{ 'k004347' | translate }}
    <!-- Token: To receive a new code, -->
    <a class="clickHere" (click)="resendCode()">{{ 'k001645' | translate }}</a></small>
    <!-- Token: Click here -->
  </p>
</div>
